import Request from '../utilis/request';

export function getInfo(params) {
    return Request({
        url:'/api/app_info',
        method:'get',
    })
}
export function getCountries(){
    return Request({
        url:'/api/countries',
        method:'get',
    })
}
export function getProgress(params) {
    return Request({
        url:'/api/app_progress',
        method:'get',
    })
}
export function sendMessage(data) {
    return Request({
        url: '/api/message',
        method: 'post',
        data: data
    })
}

export function search(data) {
    return Request({
        url: '/api/search',
        method: 'post',
        data: data
    })
}

export function serverValidation(data) {
    return Request({
        url: '/api/valid_server',
        method: 'post',
        data: data
    })
}

export function emailValidation(data) {
    return Request({
        url: '/api/valid_email',
        method: 'post',
        data: data
    })
}


